import store from '../store'
import Wallkit from "../plugins/wallkit.esm.min";

export default async (to, from, next) => {

  const cookieToken = Wallkit.getToken();
  const storeToken = store.getters['auth/token'];

  if (cookieToken && !storeToken) {
    await store.dispatch('auth/saveToken', {token: cookieToken});
  }

  next();
}



// WEBPACK FOOTER //
// ./src/middlewares/check-auth.js